import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TipoArquivo } from 'src/app/models/enum';
import { KitImagem } from 'src/app/models/kit-imagem';
import { Marca } from 'src/app/models/marca';
import { Produto } from 'src/app/models/produto';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { EnumService } from 'src/app/services/enum.service';
import { GlobalService } from 'src/app/services/global.service';
import { KitImagemService } from 'src/app/services/kit-imagem.service';
import { MarcaService } from 'src/app/services/marca.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ViaCepService } from 'src/app/services/via-cep.service';

@Component({
  selector: 'app-cadastrar-kit-imagem-modal',
  templateUrl: './cadastrar-kit-imagem-modal.component.html',
  styleUrls: ['./cadastrar-kit-imagem-modal.component.scss']
})
export class CadastrarKitImagemModalComponent implements OnInit, OnDestroy, AfterViewInit {
  // variáveis
  idKitImagem;
  kitImagem = new KitImagem();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  public config: PerfectScrollbarConfigInterface = {};
  selectedFile: File;
  nomeArquivoBanco = '';

  paineis: Produto[] = [];
  marcas: Marca[];

  constructor(private route: ActivatedRoute, private notificacaoService: NotificacaoService,
    private kitImagemService: KitImagemService, private enumService: EnumService,
    private router: Router, private viaCepService: ViaCepService, public dialog: MatDialog,
    private globalService: GlobalService, private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService, public dialogRef: MatDialogRef<CadastrarKitImagemModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private arquivoService: ArquivoService,
    private produtoService: ProdutoService, private marcaService: MarcaService) {
    this.idKitImagem = data.id;
  }

  ngOnInit() {

    this.buscarPaineis();
    this.listarMarcas();

    // se for edição, busca o kitImagem do id passado
    if (this.idKitImagem) {
      this.editando = true;
      this.buscarKitImagem();
    } else {
      this.kitImagem = new KitImagem();
      this.kitImagem.imagem = '';
      this.atualizaDadosKitImagem();
    }
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarPaineis() {
    this.carregandoService.mostra('buscaPaineis');

    this.produtoService.buscarPaineis().subscribe(
      (pa) => {
        this.paineis = pa;
        this.carregandoService.esconde('buscaPaineis');
      },
      (erro) => {
        this.carregandoService.esconde('buscaPaineis');
      }
    );
  }

  listarMarcas() {
    this.carregandoService.mostra('buscaMarcas');

    this.marcaService.listarPorFamilia(3).subscribe(
      (marcs) => {
        this.marcas = marcs;
        this.carregandoService.esconde('buscaMarcas');
      },
      (erro) => {
        this.carregandoService.esconde('buscaMarcas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarKitImagem() {

    this.carregandoService.mostra('buscaKitImagem');

    this.kitImagemService.consultarPorIdKitImagem(this.idKitImagem).subscribe(tipo => {
      this.kitImagem = tipo;
      this.nomeArquivoBanco = this.kitImagem.imagem;
      this.atualizaDadosKitImagem();
    }, (erro) => {
      this.carregandoService.esconde('buscaKitImagem');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosKitImagem() {

    this.carregando = false;

    this.carregandoService.esconde('buscaKitImagem');
  }

  salvar() {
    this.carregandoService.mostra('salvaKitImagem');

    const dados = new FormData();
    if (this.selectedFile) {
      dados.append('arquivo_consulta', this.selectedFile);
      dados.append('arqui[imagem]', this.selectedFile.name);
    } else {
      dados.append('arqui[imagem]', this.kitImagem.imagem);
    }

    dados.append('arqui[id]', this.kitImagem.id ? this.kitImagem.id.toString() : '0');
    dados.append('arqui[idPainel]', this.kitImagem.idPainel.toString());
    dados.append('arqui[idMarcaInversor]', this.kitImagem.idMarcaInversor.toString());

    this.kitImagemService.salvar(dados).subscribe(() => {
      this.notificacaoService.sucesso('Imagem de Kit salva com sucesso!!!');
      this.carregandoService.esconde('salvaKitImagem');
      this.dialogRef.close(true);

    }, (erro) => {
      this.carregandoService.esconde('salvaKitImagem');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void {

  }

  fechar() {
    this.dialogRef.close();
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  baixarArquivo() {

    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(this.idKitImagem, TipoArquivo.KitImagem).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, this.nomeArquivoBanco);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });

  }

  excluirArquivo() {
    this.selectedFile = undefined;
    this.kitImagem.imagem = '';
  }

}
